<template>
    <div class="page page-center">
        <div id="app-directory" class="app-directory-salesbox"></div>
    </div>
  
    
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        created(){
            var shop = this.$store.getters['auth/getShop'];
            if( shop ){
                window.appKey = 'salesbox';
                window.shopId = shop.id;
                window.shopDomain = shop.myshopify_domain;
                window.shopName =  shop.shop_owner;
                window.shopOwner  =  shop.shop_owner;
                let recaptchaScript = document.createElement('script')
                recaptchaScript.setAttribute('src', 'https://apps.fireapps.io/js/front.min.js')
                document.head.appendChild(recaptchaScript)
            }
            
        },

    }
</script>
<style>
    @import  "https://apps.fireapps.io/css/styles.min.css";
</style>